export const SPECIES_TEMPLATE_FIELDS = [
  'commonName', 'category', 'slug', 'scientificName', 'communityName', 'harvestCategory',
  'alternateNames', 'subType', 'shortDescription', 'habitat', 'seasonalNotes', 'stewardshipNote',
];

const templateSpecies = {
  commonName: 'Walleye', category: 'Fish', slug: 'walleye', scientificName: 'Sander vitreus',
  communityName: '', harvestCategory: 'fishing', alternateNames: ['Pickerel', 'Dore'],
  subType: '', shortDescription: '', habitat: '', seasonalNotes: '', stewardshipNote: '',
};

export const SPECIES_IMPORT_TEMPLATES = {
  csv: SPECIES_TEMPLATE_FIELDS.join(',') + '\r\n'
    + SPECIES_TEMPLATE_FIELDS.map((field) => {
      const value = Array.isArray(templateSpecies[field]) ? templateSpecies[field].join('|') : templateSpecies[field];
      return `"${value.replace(/"/g, '""')}"`;
    }).join(',') + '\r\n',
  json: JSON.stringify({ species: [templateSpecies] }, null, 2) + '\n',
};

function csvRows(text) {
  const rows = [];
  let row = [], cell = '', quoted = false, closed = false;
  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    if (quoted) {
      if (char === '"' && text[i + 1] === '"') { cell += '"'; i += 1; }
      else if (char === '"') { quoted = false; closed = true; }
      else cell += char;
    } else if (char === ',' || char === '\n' || char === '\r') {
      row.push(cell.trim()); cell = ''; closed = false;
      if (char !== ',') {
        if (row.some(Boolean)) rows.push(row);
        row = [];
        if (char === '\r' && text[i + 1] === '\n') i += 1;
      }
    } else if (char === '"') {
      if (cell || closed) throw new Error('Invalid CSV quote. Quote the entire cell and escape quotes as "".');
      quoted = true;
    } else {
      if (closed && char.trim()) throw new Error('Unexpected text after a quoted CSV cell.');
      if (!closed) cell += char;
    }
  }
  if (quoted) throw new Error('CSV contains an unclosed quoted cell.');
  row.push(cell.trim());
  if (row.some(Boolean)) rows.push(row);
  return rows;
}

export function parseSpeciesImport(raw) {
  const text = raw.replace(/^\uFEFF/, '').trim();
  if (!text) throw new Error('Choose a CSV or JSON file containing species.');
  let records;
  if (/^[{[]/.test(text)) {
    const json = JSON.parse(text);
    records = Array.isArray(json) ? json : json.species;
  } else {
    const [headers = [], ...rows] = csvRows(text);
    if (!headers.includes('commonName') || !headers.includes('category')) throw new Error('CSV headers must include commonName and category.');
    if (new Set(headers).size !== headers.length || headers.some((header) => !header)) throw new Error('CSV headers must be non-empty and unique.');
    records = rows.map((row, index) => {
      if (row.length !== headers.length) throw new Error(`CSV row ${index + 2} has the wrong number of columns.`);
      return Object.fromEntries(headers.map((header, i) => [header, header === 'alternateNames' ? row[i].split('|').map((name) => name.trim()).filter(Boolean) : row[i]]));
    });
  }
  if (!Array.isArray(records) || !records.length || records.length > 500) throw new Error('Import between 1 and 500 species at a time.');
  records.forEach((record, index) => {
    if (!record || typeof record.commonName !== 'string' || !record.commonName.trim() || typeof record.category !== 'string' || !record.category.trim()) {
      throw new Error(`Row ${index + 1}: commonName and category are required.`);
    }
  });
  return records;
}
